import { EXPRESS_API } from 'configs/api/expressApi';
import {
  ApproveDenyRequestParams,
  CreateVideoRequestParams,
  VideoRequestListParams,
} from '.';

export const getVideoRequestsCount = async (status: string) => {
  const params = {
    statuses: status,
    start: 0,
    limit: 100,
  };
  const response = await EXPRESS_API.get(`/video-requests`, { params });
  return response.data;
};

export const getVideoRequests = async (props: VideoRequestListParams) => {
  const params = {
    search: props.filter ? props.filter.search : '',
    advisorId: props.filter ? props.filter.advisorId : '',
    createdByUserId: props.filter ? props.filter.userId : '',
    videoType: props.filter ? props.filter.videoType : '',
    statuses: props.filter ? props.filter.statuses : '',
    videoId: props.filter ? props.filter.videoId : '',
    start: props.start || 0,
    limit: props.limit || 100,
  };

  const response = await EXPRESS_API.get(`/video-requests`, { params });
  return response.data;
};

export const getVideoRequest = async (videoRequestId: string | number) => {
  const response = await EXPRESS_API.get(`/video-requests/${videoRequestId}`);
  return response.data;
};

export const getVideoRequestByVideoId = async (id: string) => {
  const response = await EXPRESS_API.get(
    `/video-requests/${id}/get-by-videoid`
  );
  return response.data;
};

export const createVideoRequest = async ({
  data,
}: CreateVideoRequestParams) => {
  const response = await EXPRESS_API.post(`/video-requests`, data);
  return response.data;
};

export const updateVideoRequest = async ({
  videoRequestId,
  data,
}: CreateVideoRequestParams) => {
  const response = await EXPRESS_API.put(
    `/video-requests/${videoRequestId}`,
    data
  );
  return response.data;
};

export const approveVideoRequest = async ({
  videoRequestId,
}: ApproveDenyRequestParams) => {
  const response = await EXPRESS_API.put(
    `/video-requests/${videoRequestId}/approve`
  );
  return response.data;
};

export const denyVideoRequest = async ({
  videoRequestId,
  note,
}: ApproveDenyRequestParams) => {
  const response = await EXPRESS_API.put(
    `/video-requests/${videoRequestId}/deny`,
    {
      note,
    }
  );
  return response.data;
};
